<mat-dialog-content>
  <div class="course_popup_overlay">
    <div class="course_popup">
      <div class="course_title">{{reportPageData?.heading}}<a class="material-icons" mat-dialog-close>close</a></div>
      <div class="course_upload scrollbar">
        @if (warningMessage()) {
          <div class="warning">
            <span class="material-icons">warning_amber</span>
            <p>{{warningMessage()}}</p> <a class="material-icons" (click)="warningMessage.set('')">close</a>
          </div>
        }
        <div class="main_wrapper">
          <div class="course_section">
            <div class="campus_form">
              <div class="input_sec input_sec_100" id="reportTitleAutomationId">
                <div class="input_label">{{reportPageData?.reportTitle}} <span>*</span></div>
                <mat-form-field appearance="fill">
                  <input matInput value="" [ngModel]="reportTitle()" (ngModelChange)="reportTitle.set($event)">
                </mat-form-field>
              </div>
            </div>

            <div class="upload_file m-t-24" id="fileUploadAutomationId" (fileDropped)="uploadFile($event)" appFileDrop>
              <img [src]="imageConst.fileImage" alt="File">
              <form>
                <input type="file" id="Upload_File" #fileInput [accept]="acceptedFileFormat" (change)="uploadFile($event.target)">
                <label for="Upload_File">Upload a file <span> or drag and drop</span></label>
              </form>
              <p class="format_size m-t-4">{{acceptedFileFormat.toUpperCase()}} upto {{maxSizeInMB}}MB</p>
            </div>

            <!-- File upload progress -->
            @if (fileName()) {
              <div class="m-t-24">
                <div class="report_flex">
                  <div class="file-d-flex">
                    <div class="fill_icon"><img [src]="imageConst.fileImage" alt="File" width="12"></div>
                    <div class="file_status">
                      <div class="file_name m-b-8">{{fileName()}}</div>
                      @if (progressType() === 'loaded') {
                        <div class="format_size m-t-8">
                          <span>{{fileSize()}}</span>
                        </div>
                      }
                      @if (progressType() === 'error') {
                        <div class="format_size format_error m-t-8">Oops! Upload failed</div>
                      }
                    </div>
                  </div>
                  <div class="close_icon">
                    @if (progressType() === 'loaded') {
                      <div id="deleteButtonAutomationId" class="fill_icon delete_bg cursor_pointer" (click)="fileInput.value='';clearFileData()"><img [src]="imageConst.deleteIcon" alt="Delete"></div>
                    }
                    @if (progressType() === 'error') {
                      <div id="refreshButtonAutomationId" class="fill_icon cursor_pointer" (click)="uploadFile(selectedFile())"><img [src]="imageConst.refreshImage" alt="Refresh"></div>
                    }
                  </div>
                </div>
              </div>
            }
            <!-- File upload progress -->

          </div>
        </div>
      </div>
      <div class="course_pop_btn">
        <div id="cancelButtonAutomationId" class="btn_cancel" mat-dialog-close>Cancel</div>
        <div class="course_btn_group">
          <button id="submitButtonAutomationId" class="save_btn" [ngClass]="{'dis_btn': isSubmitDisabled()}" (click)="uploadSubjectReport()" mat-stroked-button>SUBMIT</button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
